import { FC } from 'react';
import { useIsFetching } from 'react-query';
import styled from 'styled-components';
import { LinearProgress } from 'components';

const Wrapper = styled.div`
    height: 10px;
`;

export const LoadingIndicator: FC<{ show?: boolean }> = ({ show }) => {
    const isFetching = useIsFetching();

    return <Wrapper>{(!!isFetching || show) && <LinearProgress />}</Wrapper>;
};
